import * as fromState from './custom-forms.state';
import * as fromActions from './custom-forms.actions';
import * as Objects from '@core/objects';
import * as CFormsSearch from '@core/custom-forms/models/field-search.model';

export function customFormsReducer(state = fromState.initialState, action: fromActions.CustomFormsActions): fromState.CustomForms { 
    switch (action.type) {
        case fromActions.CustomFormsActionType.LoadFilterLabelsSuccess:
            return {...state, 
                available_filters: {...state.available_filters, 
                    labels: {...state.available_filters.labels, items: action.labels }
                },
                starting: {...state.starting,
                    labels_ready: true
                }
            };
        
        case fromActions.CustomFormsActionType.LoadFilterLabelsError:
            return state;
        
        case fromActions.CustomFormsActionType.LoadFilterStatusSuccess:
            return {...state, 
                available_filters: {...state.available_filters, 
                    status: {...state.available_filters.status, items: action.status }
                },
                starting: {...state.starting,
                    status_ready: true
                }
            };
        
        case fromActions.CustomFormsActionType.LoadFilterStatusError:
            return state;
        
        case fromActions.CustomFormsActionType.LoadCategoriesSuccess:
            return {...state, 
                categories: action.categories,
                starting: {...state.starting,
                    categories_ready: true
                }
            }
        
        case fromActions.CustomFormsActionType.LoadCategoriesError:
            return {...state, categories: [] }
            
        case fromActions.CustomFormsActionType.LoadUsersSuccess:
            return {...state, 
                users: action.users,
                starting: {...state.starting,
                    users_ready: true
                }
            }
        
        case fromActions.CustomFormsActionType.LoadUsersError:
            return {...state, users: [] }

        case fromActions.CustomFormsActionType.InitializeSearch:
            return {
                ...state,
                searches: {
                    ...state.searches,
                    [action.uuid]: { ...fromState.initialSearchState }  // Reset state for the specific uuid
                }
            };
        
        case fromActions.CustomFormsActionType.SearchArtworks:
            const currentSearch = state.searches[action.uuid];  // Get the current search state for the uuid

            if (!currentSearch) {
                return state;  // If there's no search initialized for this uuid, return state unchanged
            }

            return {
                ...state,
                searches: {
                    ...state.searches,
                    [action.uuid]: {
                        ...currentSearch,
                        artwork_results: {
                            ...currentSearch.artwork_results,
                            status: CFormsSearch.SearchHttpStatus.LOADING  // Set status to LOADING when the search is triggered
                        }
                    }
                }
            };

        case fromActions.CustomFormsActionType.SearchArtworksSuccess: {
            const currentSearch = state.searches[action.uuid];  // Get the search data for the specific uuid

            // If no search exists for the uuid, return state unchanged (shouldn't happen if initialized correctly)
            if (!currentSearch) {
                return state;  
            }
        
            const status = action.versions.length < currentSearch.search.limit 
                ? CFormsSearch.SearchHttpStatus.FINAL 
                : CFormsSearch.SearchHttpStatus.DONE;
        
            switch (currentSearch.artwork_results.next_page) {
                case 1:
                    return {
                        ...state,
                        searches: {
                            ...state.searches,
                            [action.uuid]: {
                                ...currentSearch,
                                artwork_results: {
                                    ...currentSearch.artwork_results,
                                    items: action.versions,   // Set the versions when it's the first page
                                    next_page: 2,
                                    status: status
                                }
                            }
                        }
                    };
                
                default:
                    return {
                        ...state,
                        searches: {
                            ...state.searches,
                            [action.uuid]: {
                                ...currentSearch,
                                artwork_results: {
                                    ...currentSearch.artwork_results,
                                    items: [
                                        ...currentSearch.artwork_results.items.filter(
                                            (v: Objects.Version) => !action.versions.some((vv: Objects.Version) => v.id === vv.id)
                                        ),  // Keep only unique versions
                                        ...action.versions
                                    ],
                                    next_page: currentSearch.artwork_results.next_page + 1,
                                    status: status
                                }
                            }
                        }
                    };
            }
        }
           
        case fromActions.CustomFormsActionType.SetSearchTerm:
            return {...state,
                searches: {
                    ...state.searches, 
                    [action.uuid]: {
                        ...state.searches[action.uuid],
                        search: {
                            ...state.searches[action.uuid].search,
                            term: action.term
                        }
                    }
                }
            };
        
        case fromActions.CustomFormsActionType.SetQueryParams:
            // reset page also
            return {...state,
                searches: {
                    ...state.searches,
                    [action.uuid]: {
                        ...state.searches[action.uuid],
                        search_query_params: action.params,
                        artwork_results: {
                            ...state.searches[action.uuid].artwork_results,
                            next_page: 1,
                            status: CFormsSearch.SearchHttpStatus.INITIAL
                        }
                    }
                }
            };
        
        case fromActions.CustomFormsActionType.ApplySearchFilter: 
            const existingFilters = state.searches[action.uuid]?.search.filters || [];
  
            // Filtrar nuevos filtros para evitar duplicados
            const newFilters = action.filters.filter(newFilter =>
              !existingFilters.some(existing =>
                existing.key === newFilter.key && existing.identifier === newFilter.identifier
              )
            );
          
            // Si no hay filtros nuevos, devolver el estado sin cambios
            if (newFilters.length === 0) {
              return state;
            }

            return {
                ...state,
                searches: {
                    ...state.searches,
                    [action.uuid]: {
                        ...state.searches[action.uuid],
                        search: {
                            ...state.searches[action.uuid].search,
                            filters: [...existingFilters, ...action.filters]  // Merge new filters array
                        }
                    }
                }
            };
        case fromActions.CustomFormsActionType.RemoveSearchFilter:
            return {
                ...state,
                searches: {
                    ...state.searches,
                    [action.uuid]: {
                        ...state.searches[action.uuid],
                        search: {
                            ...state.searches[action.uuid].search,
                            filters: state.searches[action.uuid].search.filters.filter((f: CFormsSearch.SearchAppliedFilter) => !(f.key == action.filter.key && f.identifier == action.filter.identifier))
                        }
                    }
                }
            };

        case fromActions.CustomFormsActionType.CleanArtworks:
            return {...state, 
                searches: {
                    ...state.searches,
                        [action.uuid]: { ...fromState.initialSearchState }  // Reset state for the specific uuid
                    }
            };
        
                
        default:
            return state;
    }
}